import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Form, Input } from "antd";
import { AuthInfo } from "stores/slices/auth";
import {
  doAddCardWorkspace,
  isSaving,
  WorkspaceInfo,
} from "stores/slices/workspace";

import AppButton from "../../../components/button";

const AddCard = props => {
  const {
    workspaceId,
    isGoToPayment,
    isShowCancelButton,
    onSuccess,
    onCancel,
  } = props;
  const formRef = React.useRef(null);

  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const location = useLocation();

  const authInfo = useSelector(AuthInfo);
  const workspaceDetail = useSelector(WorkspaceInfo);
  const loading = useSelector(isSaving);

  const [errorCard, setErrorCard] = useState("");
  const [isCompleted, setIsCompleted] = useState(false);

  const onFinish = async value => {
    if (!isCompleted) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    const result = await stripe
      .createToken(cardElement)
      .then(payload => {
        if (payload && payload.token && payload.token.id) {
          return payload.token.id;
        }
        setErrorCard(
          payload.error && payload.error.message ? payload.error.message : ""
        );
      })
      .catch(err => {
        console.log(err);
      });
    if (result && value.cardHolder) {
      const request = {
        externalId: workspaceId
          ? workspaceId
          : location?.state?.workspaceId
          ? location?.state?.workspaceId
          : authInfo?.workspaceId,
        cardToken: result,
        cardHolder: value.cardHolder,
      };
      const { payload } = await dispatch(doAddCardWorkspace(request));
      if (payload && payload.status === 200) {
        toast.success(
          workspaceDetail.stripLast4Digit
            ? t("toast.updateCardSuccess")
            : t("toast.addCardSuccess")
        );

        if (isGoToPayment) {
          if (location?.state?.workspaceId) {
            navigate(`/admin/payment/${id}`, {
              state: {
                workspaceId: location?.state?.workspaceId,
              },
            });
          } else {
            navigate(`/admin/payment/${id}`);
          }
        } else {
          elements.getElement(CardElement).clear();
          formRef.current.setFieldsValue({
            cardHolder: "",
          });
          onSuccess();
        }
      }
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          ref={formRef}
          name="basic"
          layout="vertical"
          style={{
            width: "400px",
          }}
          initialValues={{
            cardHolder: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Form.Item
              label={t("payment.cardHolder")}
              name="cardHolder"
              rules={[
                {
                  required: true,
                  message: "Please input your card holder!",
                },
              ]}
              style={{
                width: "400px",
                marginBottom: "14px",
              }}
            >
              <Input
                maxLength={255}
                type="text"
                size="large"
                placeholder={t("payment.cardHolder")}
              />
            </Form.Item>
            <Form.Item
              label={t("payment.cardNumber")}
              style={{
                width: "400px",
                marginBottom: "0px",
              }}
            >
              <CardElement
                onChange={event => {
                  setIsCompleted(event.complete);
                  setErrorCard(event.error?.message || "");
                }}
              />
              <div>
                <span style={{ color: "red" }}>{errorCard}</span>
              </div>
            </Form.Item>
            <div
              style={{
                width: "100%",
                marginTop: "12px",
                display: "flex",
                justifyContent: "end",
                gap: "16px",
              }}
            >
              {isShowCancelButton && (
                <AppButton
                  label={t("button.cancel")}
                  color={"grey"}
                  loading={!stripe || loading}
                  htmlType="button"
                  onClick={() => {
                    elements.getElement(CardElement).clear();
                    formRef.current.setFieldsValue({
                      cardHolder: "",
                    });
                    onCancel();
                  }}
                />
              )}

              <AppButton
                label={
                  workspaceDetail.stripLast4Digit
                    ? t("button.save")
                    : t("payment.addCard")
                }
                color={"blue"}
                loading={!stripe || loading}
                type="primary"
                htmlType="submit"
              />
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};
export default AddCard;
